/** Default report builder form state; preset merges quick-action or slot overrides. */
export const createInitialBuilderDraft = (preset = {}) => ({
  mainModuleId: null,
  mainModuleName: '',
  relatedModuleNames: [],
  window_info: {
    window_id: '',
    related_window: [],
    relatedSelWindow: [],
  },
  reportPreviewFields: {
    window_fields: {},
    numeric_fields: null,
  },
  fieldsLoading: false,
  fieldsError: null,
  outputType: 'table',
  vizType: null,
  availableFields: [],
  roles: {
    columns: [],
    groupBy: '',
    groupByGranularity: 'month',
    summaryMetricField: '',
    summaryAggregation: 'count',
    chartType: 'line',
    xAxis: '',
    xGranularity: 'month',
    yAxis: '',
    yAggregation: 'sum',
    series: '',
    slice: '',
    value: '',
    valueAggregation: 'sum',
    kpiField: '',
    kpiAggregation: 'sum',
    kpiDateFieldId: '',
    kpiDateFieldName: '',
    kpiLabel: '',
    kpiComparisonPeriod: 'NONE',
    kpiShowGrowthPercent: true,
    kpiShowPreviousValue: true,
    kpiShowTrendArrow: true,
    kpiTargetValue: '',
  },
  filters: [],
  filterLogic: 'and',
  reportName: '',
  reportId: null,
  folderId: null,
  chartId: null,
  existsChart: false,
  visibility: 'private',
  destination: 'save',
  targetDashboardId: null,
  targetWidgetId: null,
  slotContext: null,
  isEditingExistingReport: false,
  editFromDashboard: false,
  dashboardLayoutId: null,
  ...preset,
});

/** outputType/vizType defaults for empty-state quick actions and dashboard slot types. */
export const mapQuickActionPreset = (actionId) => {
  switch (actionId) {
    case 'kpi':
      return {
        outputType: 'metrics',
        vizType: 'kpi',
        roles: { chartType: 'kpi' },
      };
    case 'chart':
      return {
        outputType: 'metrics',
        vizType: 'bar',
        roles: { chartType: 'bar' },
      };
    case 'table':
      return { outputType: 'table', vizType: 'table' };
    default:
      return {};
  }
};
